import React, { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { callFunctionDkView, callGTMAnalytics } from '../../helper/analyticsTag';
import { createUrlSlug, getLangSite } from '../../ultils';
import { frameworkComponents } from '../cell-render';
import { useTranslation } from 'react-i18next';
import {
    REVERSE_SEARCH_GRID_OPTIONS,
} from '../../constants';
import reverseResultAtom from '../../recoils/useReverseResult/reverseResultAtom';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import queryStringAtom from '../../recoils/useQueryString/queryStringAtom';
import './vertical-ui-ag-grid-table.scss'
import isUsingLocalStoredAtom from '../../recoils/useIsUsingLocalStored/IsUsingLocalStoredAtom';

interface IProp {
    columnDefs: any;
    pinRowData: any;
    isReverse?: any;
    isHorizontalView?: any;
}

export const VerticalViewTable: React.FC<IProp> = ({
    columnDefs,
    pinRowData,
    isReverse
}) => {
    const [listCheckbox] = useRecoilState(selectedCheckboxsAtom);

    const [queryString] = useRecoilState(queryStringAtom);

    const [utagObject] = useRecoilState(utagObjectAtom);

    const setIsUsingLocalStoraged = useSetRecoilState(isUsingLocalStoredAtom);

    const event_state_ref = useRef<string[]>([]);

    const { t } = useTranslation();

    const handleButton = async (queryString: string) => {
        const langSiteObj = getLangSite('en');
        const lang = langSiteObj.lang;
        const utagUpdate = {
            ...utagObject,
            ...{
                ref_page_event: 'View Similar Parts',
                event_state: event_state_ref.current.join(',')
            }
        };
        callGTMAnalytics(utagUpdate);
        callFunctionDkView(utagUpdate);
        window.open(
            `https://${window.location.host}/${lang}/products/category/${createUrlSlug(
                pinRowData[0].category.name,
                true
            )}/${pinRowData[0].category.categoryId}?s=${queryString}`
        );
    };

    const [result] = useRecoilState(reverseResultAtom);
    const colDefs = columnDefs.filter((col: any) => {
        return col.field !== 'crossType.crossName' && col.field !== 'supplier' && col.field !== 'rohsStatus' && col.field !== 'primaryDatasheetUrl' && col.field !== 'catalogDescription' && col.field !== 'primaryPhotoUrl';
    });

    if (colDefs) {
        var firstDataColumn = colDefs.map((col: any) => {
            return { "firstColumn": col.headerName, "fieldMapping": col.field, "parameterId": col.parameterId }
        })
        if (pinRowData) {
            var secondDataColumn = Object.keys(pinRowData[0])
                .map((field: string) => {
                    return { "secondColumn": { [field]: pinRowData[0][field] }, "fieldMapping": field }
                })
            if (firstDataColumn && secondDataColumn) {
                var finalData = firstDataColumn.map((firstData: any) => {
                    let finded: any = secondDataColumn.find((sencondData: any) => {
                        return sencondData["fieldMapping"] === firstData["fieldMapping"]
                    })
                    return { "firstColumn": firstData.firstColumn, "secondColumn": finded ? finded.secondColumn : pinRowData[0].productVariations, "fieldMapping": firstData["fieldMapping"], "sourceData": pinRowData[0], "parameterId": firstData.parameterId }
                })
            }
        }
    }

    
    const firstColum = [{ field: "firstColumn", minWidth: 245 }, { field: "secondColumn", cellRenderer: "customColumnDataCellRenderer", minWidth: 400 }, { field: "checkBoxColumn", cellRenderer: "customColumnDataCellRenderer" }];
    const firstColumnData = finalData ? [...finalData] : []
   
    //convert column field array to column header name array
    if (listCheckbox.length > 0 && firstColumnData.length >0) {
       let event_state_array: string[] = [];
       listCheckbox.forEach((iCheckbox: string) => {
         const result = firstColumnData.find((iCol: any) => {
           return iCol.fieldMapping === iCheckbox;
         });
         if (result)
           event_state_array = [...event_state_array, result.firstColumn];
       });
       event_state_ref.current = event_state_array;
    }

    const onFirstDataRendered = () => {
        setIsUsingLocalStoraged(false);
    }

    return (
        <div className="vertical-view">
            <AgGridReact
                gridOptions={REVERSE_SEARCH_GRID_OPTIONS}
                columnDefs={firstColum}
                frameworkComponents={frameworkComponents}
                enableRtl={isReverse}
                rowData={firstColumnData}
                pinnedTopRowData={[]}
                suppressContextMenu={true}
                onFirstDataRendered={onFirstDataRendered}

            />

            <div className="result-and-button-view-matching-container">
                <button
                    id="view-all-btn"
                    data-testid="view-all-btn"
                    className="dk-btn__primary btnViewMatching ml-0 mr-3"
                    onClick={() => handleButton(queryString)}
                    {...{
                        ref_page_event: 'View Similar Parts',
                        event_state: `${event_state_ref.current.join(',')}`
                    }}
                >
                    {t('xref-view-matching-parts')}
                </button>
                {listCheckbox.length > 0 && result && (
                    <span className="matching-result">
                        {result} {t('xref-results')}
                    </span>
                )}
            </div>

        </div>
    );
};
